// extracted by mini-css-extract-plugin
export default {"formu":"informations_formu__R3tnq","span":"informations_span__yJ3b2","label":"informations_label__yrOvK"};